import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Root from "./root";

import * as serviceWorker from "./serviceWorker";

import "./index.scss";
import Normalize from "react-normalize";

try {
  ReactDOM.render(
    <React.StrictMode>
      <Root>
        <Normalize />
        <App />
      </Root>
    </React.StrictMode>,
    document.getElementById("root")
  );
} catch (error) {
  alert(error)
  alert("An error has occurred, you have been logged out.");
  //window.localStorage.clear(); //clear any saved state
  //window.location.reload(); // reload page
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
